import React, { useState, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import BackAnchor from 'shared/components/BackAnchor'
import { useDispatch, useSelector } from 'react-redux'
import { changeObjectPropertyAction } from 'redux/actions'
import ContinueCancelButtons from 'shared/components/ContinueCancelButtons'

const AddressesToChangeView = ({ t, i18n }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [errorMsg, setErrorMsg] = useState('')
  const { homeAddress, mailingAddress } = useSelector((state) => state.app.addressesToChange)
  const { nsHealthCard } = useSelector((state) => state.app.addressTypeChange);

  const handleRadio = (e) => {
    let field = e.currentTarget.value;
    const newHomeAddress = field === "homeAddress" || field === "both";
    const newMailingAddress = field === "mailingAddress" || field === "both";

    dispatch(changeObjectPropertyAction('addressesToChange', 'homeAddress', newHomeAddress));
    dispatch(changeObjectPropertyAction('addressesToChange', 'mailingAddress', newMailingAddress));
  }

  const onContinueClick = () => {
    if (!homeAddress && !mailingAddress) {
      setErrorMsg(t('addresses_to_change.select_option'))
      return;
    }

    if (nsHealthCard) {
      history.push(`/${i18n.language}${t('routes.new_address_effective')}`)
    } else {
      history.push(`/${i18n.language}${t('routes.new_address')}`)
    }
  }


  const { driverLicence, registeredByName, jointlyRegistered, registeredBusiness } = useSelector((state) => state.app.addressTypeChange)
  const isCivic = useMemo(() => {
    return !(nsHealthCard || driverLicence || registeredByName || jointlyRegistered) && registeredBusiness
  }, [driverLicence, registeredByName, jointlyRegistered, registeredBusiness, nsHealthCard]);


  return (
    <div className="container">
      <main>
        <article>
          <BackAnchor />
          <div className="row">
            <div className="col-xs-12">
              <h1>{t('addresses_to_change.what_addresses_to_change')}</h1>
              <div className='ns-radios__item'>
                <input className="ns-radios__input" type="radio" id={"homeAddress"} value="homeAddress" onChange={handleRadio}
                  checked={homeAddress && !mailingAddress} />
                <label className="ns-label ns-radios__label" htmlFor={t('addresses_to_change.home_address')} key={t('addresses_to_change.home_address')}>
                  <span className="ns-label-span">{isCivic ? t('new_address.civic_address') : t('new_address.home_address')}</span>
                </label>
              </div>
              <div className='ns-radios__item'>
                <input className="ns-radios__input" type="radio" id={"mailingAddress"} value="mailingAddress" onChange={handleRadio}
                  checked={!homeAddress && mailingAddress} />
                <label className="ns-label ns-radios__label" htmlFor={t('addresses_to_change.mailing_address')} key={t('addresses_to_change.mailing_address')}>
                  <span className="ns-label-span">{t('addresses_to_change.mailing_address')}</span>
                </label>
              </div>
              <div className='ns-radios__item'>
                <input className="ns-radios__input" type="radio" id={"both"} value="both" onChange={handleRadio}
                  checked={homeAddress && mailingAddress} />
                <label className="ns-label ns-radios__label" htmlFor={t('addresses_to_change.both')} key={t('addresses_to_change.both')}>
                  <span className="ns-label-span">{t('addresses_to_change.both')}</span>
                </label>
              </div>

            </div>
          </div>
          <ContinueCancelButtons continueClick={onContinueClick} errorText={errorMsg} />
        </article>
      </main >
    </div >
  )
}

export default withTranslation('common')(AddressesToChangeView)
